import WorkLoadAnalysisReport from "./WorkLoadAnalysisReport";
export default WorkLoadAnalysisReport;